import { Lock, ChevronRight, ArrowUpRight } from "lucide-react";
import { Button } from "components";
import "./styles.css";

interface LockedStateProps {
  title: string;
  description: string;
  onUpgrade?: () => void;
  onLearnMore?: () => void;
}

const LockedState = ({ title, description, onUpgrade, onLearnMore }: LockedStateProps) => {
  return (
    <div className="locked-state">
      <div className="locked-state-icon-container">
        <Lock className="locked-state-icon" size={32} />
      </div>
      <h2 className="locked-state-title">{title}</h2>
      <p className="locked-state-description">{description}</p>
      <div className="locked-state-actions">
        {onUpgrade && (
          <Button variant="primary" size="medium" onClick={onUpgrade} icon={ChevronRight} iconPosition="right">
            Upgrade to unlock
          </Button>
        )}
        {onLearnMore && (
          <button className="locked-state-learn-more" onClick={onLearnMore}>
            Learn more
            <ArrowUpRight size={16} />
          </button>
        )}
      </div>
    </div>
  );
};

export default LockedState;

